import ProductCardComponent from "@/components/ProductCard";
import {
  SVGArrowLeft as SVGArrowLeftComponent,
  SVGArrowRight as SVGArrowRightComponent,
} from "@/lib/svg";
import {
  Swiper as SwiperComponent,
  SwiperSlide as SwiperSlideComponent,
  Pagination,
} from "@/lib/swiper";
import { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Wrapper, ButtonNext, ButtonPrev } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const ProductCard = ProductCardComponent as any;
const SVGArrowLeft = SVGArrowLeftComponent as any;
const SVGArrowRight = SVGArrowRightComponent as any;
const Swiper = SwiperComponent as any;
const SwiperSlide = SwiperSlideComponent as any;

type RelatedProductProps = {
  products: {
    _id: string;
    slug: string;
    title: string;
    thumbnail: any;
    param1: {
      name: string;
      values: string[];
    };
    param2: {
      name: string;
      values: string[];
    };
    param3: {
      name: string;
      values: string[];
    };
    eco: string | null;
  }[];
};

const RelatedProductsItem: React.FC<RelatedProductProps> = ({ products }) => {
  const [swiper, setSwiper] = useState<any>();

  if (products.length) {
    return (
      <Wrapper>
        <Swiper
          breakpoints={{
            320: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          spaceBetween={0}
          pagination={{ clickable: false }}
          modules={[Pagination]}
          onSwiper={(swiper: any) => setSwiper(swiper)}
        >
          {products?.map((product, index) => (
            <SwiperSlide key={`${product._id}-${index}`}>
              <ProductCard
                key={product._id}
                image={product.thumbnail}
                slug={product.slug}
                name={product.title}
                subheading={product.param1.values?.join(", ") || ""}
                param1={{
                  label: product.param2.name,
                  value: product.param2.values?.join(", ") || "",
                }}
                param2={{
                  label: product.param3.name,
                  value: product.param3.values?.join(", ") || "",
                }}
                eco={product.eco ? product.eco[0] : ""}
              />
            </SwiperSlide>
          ))}
          <ButtonPrev
            icon={<SVGArrowLeft />}
            onClick={() => swiper.slidePrev()}
          />
          <ButtonNext
            icon={<SVGArrowRight />}
            onClick={() => swiper.slideNext()}
          />
        </Swiper>
      </Wrapper>
    );
  }

  return null;
};

export default RelatedProductsItem;
